/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

// TODO : https://product-fabric.atlassian.net/browse/DSP-3537

import React from 'react';

export function GoogleIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.6412 6.42664L20.0279 3.11999C17.9479 1.18666 15.2413 0 12.0012 0C7.30792 0 3.25458 2.69332 1.28125 6.6133L5.16125 9.62662C6.13458 6.7333 8.82792 4.63998 12.0012 4.63998C14.2546 4.63998 15.7746 5.61331 16.6412 6.42664Z"
				fill="#EB4335"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.52 12.2666C23.52 11.2799 23.44 10.5599 23.2667 9.81323H12V14.2665H18.6133C18.48 15.3732 17.76 17.0399 16.16 18.1599L19.9467 21.0932C22.2133 18.9999 23.52 15.9199 23.52 12.2666V12.2666V12.2666Z"
				fill="#4285F4"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.17333 14.3732C4.92 13.6266 4.77333 12.8266 4.77333 11.9999C4.77333 11.1733 4.92 10.3733 5.16 9.6266L1.28 6.61328C0.466667 8.23994 0 10.0666 0 11.9999C0 13.9332 0.466667 15.7599 1.28 17.3866L5.17333 14.3732V14.3732Z"
				fill="#FBBC05"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0006 24C15.2406 24 17.9606 22.9334 19.9473 21.0934L16.1606 18.1601C15.1473 18.8667 13.7873 19.3601 12.0006 19.3601C8.82728 19.3601 6.13394 17.2667 5.17394 14.3734L1.29395 17.3867C3.26728 21.3067 7.30728 24 12.0006 24V24V24Z"
				fill="#34A853"
			/>
		</svg>
	);
}
